import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDUXu4wJN4VwH6FjhqBkSiV2QEt5P57HTs",
  authDomain: "matrimony-app-2c8eb.firebaseapp.com",
  projectId: "matrimony-app-2c8eb",
  storageBucket: "matrimony-app-2c8eb.firebasestorage.app",
  messagingSenderId: "50726917359",
  appId: "1:50726917359:web:40a9c706e3b330df8d371a",
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);

export const requestForToken = async () => {
  try {

    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("Notification permission denied");
      return "";
    }

    const token = await getToken(messaging, {
      vapidKey: "BN1EInH--q-M67bWHkJ5fys1ADNkp--QoAI3MTkSmPReLGYFl3_NZrwRLSXeGKal3vN5b1bGIHBe9dsWNrkblI8"
    });

    console.log("FCM Token:", token);

    return token || "";

  } catch (err) {
    console.error(err);
    return "";
  }
};

export default app;